import * as _ from 'lodash';
import * as PIXI from 'pixi.js';

import Utils from '@/assets/js/Utils';
import GameManager from '@/assets/js/game/GameManager';
import Player from '@/assets/js/game/Player';
import TextureManager from '@/assets/js/game/TextureManager';

const SPRITE_WIDTH = 54;
const SPRITE_HEIGHT = 54;
const RANDOM_POSITION_RANGE = 80;
const REMOVE_POSITION_X = 180;
const REMOVE_POSITION_Y = 0;
const REMOVE_ANGLE = 45;
const SPEED = 0.4;

let stage, spriteList;

export default class ScoreAnimation {
  static init(parentStage) {
    stage = parentStage;
    spriteList = [];
  }

  static start() {
    const key = _.sample(['star_white', 'star_yellow']);
    const texture = TextureManager.get(key);
    const sprite = new PIXI.Sprite(texture);
    const randomX = GameManager.calcRatio(
      _.random(-RANDOM_POSITION_RANGE, RANDOM_POSITION_RANGE)
    );
    const randomY = GameManager.calcRatio(
      _.random(-RANDOM_POSITION_RANGE, RANDOM_POSITION_RANGE)
    );
    const x = Player.centerX + randomX - sprite.width * 0.5;
    const y = Player.centerY + randomY - sprite.height * 0.5;

    sprite.width = GameManager.calcRatio(SPRITE_WIDTH);
    sprite.height = GameManager.calcRatio(SPRITE_HEIGHT);
    sprite.x = x;
    sprite.y = y;
    sprite.startPosition = { x: x, y: y };
    sprite.angle = _.random(360);
    sprite.startAngle = sprite.angle;
    sprite.totalTime = 0;
    sprite.isRemove = false;

    stage.addChild(sprite);

    spriteList.push(sprite);
  }

  static update(delta) {
    if (spriteList.length <= 0) return;
    _.forEach(spriteList, (sprite, index) => {
      sprite.totalTime += delta;
      let timeFraction = Utils.msToSecond(sprite.totalTime) / SPEED;
      if (timeFraction > 1) timeFraction = 1;
      const progress = Utils.timing('quad', timeFraction);
      ScoreAnimation.draw(sprite, progress);

      if (timeFraction >= 1) {
        sprite.isRemove = true;
        stage.removeChild(sprite);
      }
    });
    _.remove(spriteList, sprite => sprite.isRemove);
  }

  static draw(sprite, progress) {
    const goalX = GameManager.calcRatio(REMOVE_POSITION_X) - sprite.width * 0.5;
    const goalY =
      GameManager.calcRatio(REMOVE_POSITION_Y) - sprite.height * 0.5;

    const distanceX = goalX - sprite.startPosition.x;
    const distanceY = goalY - sprite.startPosition.y;

    sprite.x = sprite.startPosition.x + distanceX * progress;
    sprite.y = sprite.startPosition.y + distanceY * progress;
    sprite.angle = sprite.startAngle + REMOVE_ANGLE * progress;
  }
}
